import { Fieldset } from 'primereact/fieldset';
import React from 'react';
import Item from '../../indicadorSolicitacoes/components/item/Item';
import styles from './DadosDaSolicitacao.module.scss';

function DadosSolicitacao({ dataCadastro, contaAcessoCadastro, meta = {} }) {
    return (
        <Fieldset className={`${styles.fieldset} p-mt-2`} legend={'Dados da Solcitação:'}>
            <div className={`p-grid p-fluid p-col-12 ${styles.containerItems}`}>
                <Item label="Data:" value={dataCadastro} />
                <Item label="Usuário:" value={contaAcessoCadastro} />
                <Fieldset className={`${styles.fieldset} p-mt-2 p-col-12`} legend={'Meta:'}>
                    <div className={`p-grid p-fluid p-col-12 ${styles.containerItems}`}>
                        <Item label="Meta:" value={meta?.descMeta} />
                        <Item label="Previsão de Apuração:" value={meta?.dataPrevisaoApuracao} />
                        <Item
                            label="Unidade de Medida:"
                            value={meta?.unidadeMedidaMeta?.descUnidadeMedida}
                        />
                        <Item
                            label="Periodicidade:"
                            value={meta?.periodicidadeMeta?.siglaPeriodicidade}
                        />
                        <Item label="Situação:" value={meta?.situacao?.descSituacaoMeta} />
                    </div>
                </Fieldset>
            </div>
        </Fieldset>
    );
}

export default DadosSolicitacao;
